import { useTranslation } from "react-i18next";
import { Icon, Label } from "semantic-ui-react";

import { DMS_WARNING_SERVERITIES } from "models";

const severityClassMap: Record<DMS_WARNING_SERVERITIES, string> = {
  [DMS_WARNING_SERVERITIES.Log]: "severity-log",
  [DMS_WARNING_SERVERITIES.Warning]: "severity-warning",
  [DMS_WARNING_SERVERITIES.Error]: "severity-error",
  [DMS_WARNING_SERVERITIES.Critical]: "severity-critical"
};

const severityLabelMap: Record<DMS_WARNING_SERVERITIES, string> = {
  [DMS_WARNING_SERVERITIES.Log]: "Log",
  [DMS_WARNING_SERVERITIES.Warning]: "Warning",
  [DMS_WARNING_SERVERITIES.Error]: "Error",
  [DMS_WARNING_SERVERITIES.Critical]: "Critical"
};

type SeverityLabelProps = {
  severity: DMS_WARNING_SERVERITIES;
};

export const SeverityLabel = ({ severity }: SeverityLabelProps) => {
  const { t } = useTranslation();

  return (
    <Label className={severityClassMap[severity]}>
      <Icon name={severity === DMS_WARNING_SERVERITIES.Log ? "comment outline" : "warning sign"} />
      {t(`v8_${severityLabelMap[severity].toLowerCase()}`, severityLabelMap[severity])}
    </Label>
  );
};
